<h3 mat-dialog-title class="pb-2">{{ data.message }}</h3>
<mat-dialog-actions class="action-btn">
  <button mat-stroked-button color="primary" (click)="onYesClick()">Yes</button>
  <button mat-flat-button color="primary" (click)="onNoClick()">No</button>
</mat-dialog-actions>
